import React from "react";

export default function Li({ object }) {
  return <li>{object}</li>;
}
